import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { DeleteOutlined, FileImageOutlined, LoadingOutlined } from '@ant-design/icons';
import styled from '@xstyled/styled-components';
import { Button } from 'antd';
import { TextInput } from './text-input.component';
import { styleVariables } from '../../style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SuffixWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-input-suffix > *:not(:last-child) {\n    margin: 0;\n  }\n"])));
var UtilityButton = styled(Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 0;\n  border: none;\n\n  &:hover {\n    color: ", ";\n  }\n"])), styleVariables.colors.blue3);
export var TextOptionInput = function TextOptionInput(props) {
  var onFocus = props.onFocus,
      onBlur = props.onBlur,
      onDelete = props.onDelete,
      isDeleting = props.isDeleting,
      onOpenMathEditorModal = props.onOpenMathEditorModal,
      isHiddenDelete = props.isHiddenDelete,
      isHiddenAttachment = props.isHiddenAttachment,
      onShowingUploadImageModal = props.onShowingUploadImageModal,
      value = props.value,
      onChange = props.onChange,
      placeholder = props.placeholder,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      allowClear = props.allowClear,
      size = props.size,
      hasImage = props.hasImage,
      _props$isUploadFileIc = props.isUploadFileIconVisible,
      isUploadFileIconVisible = _props$isUploadFileIc === void 0 ? true : _props$isUploadFileIc;

  var handleShowingUploadAnswerFileModal = function handleShowingUploadAnswerFileModal(e) {
    e.stopPropagation();
    onShowingUploadImageModal();
  };

  var isShowingUploadFileImage = isUploadFileIconVisible && !hasImage;
  return /*#__PURE__*/_jsx(TextInput, {
    allowClear: allowClear,
    value: value,
    defaultValue: defaultValue,
    onChange: onChange,
    disabled: disabled && !isDeleting,
    size: size,
    onFocus: onFocus,
    onBlur: onBlur //ToDo: After we have function for that!!!!
    ,
    suffix: /*#__PURE__*/_jsxs(SuffixWrapper, {
      children: [isShowingUploadFileImage && /*#__PURE__*/_jsx(UtilityButton, {
        disabled: disabled && !isDeleting,
        icon: /*#__PURE__*/_jsx(FileImageOutlined, {}),
        onClick: handleShowingUploadAnswerFileModal
      }), !isHiddenDelete && /*#__PURE__*/_jsx(UtilityButton, {
        onMouseDown: function onMouseDown(e) {
          return onDelete(e);
        },
        icon: isDeleting ? /*#__PURE__*/_jsx(LoadingOutlined, {}) : /*#__PURE__*/_jsx(DeleteOutlined, {}),
        disabled: disabled && !isDeleting
      })]
    }),
    placeholder: placeholder
  });
};